import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=68ff78d7&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"
import style0 from "./PostList.vue?vue&type=style&index=0&id=68ff78d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff78d7",
  null
  
)

export default component.exports